// toast-bus.ts — geteilter Toast-Dispatch (PFS-598, Konsolidierung PFS-591).
//
// Die Toast-SENKE (`<pfs-toast-host>`) war schon generisch; der DISPATCH-Helfer
// war in jeder Cut-App (identity/practice/scheduling) wort-identisch dupliziert.
// Hier einmal, analog zu dispatchBanner/dispatchOverlay. JEDE User-Rueckmeldung
// (Erfolg/Validierung/Fehler) laeuft ueber das shell-weite `<pfs-toast-host>` —
// WCs rendern KEINE eigenen Inline-Alerts (Shell-Chrome-Konsistenz).
//
// Texte deutsch als Default (i18n-Externalisierung folgt via PFS-418, wie die
// uebrigen @pfs/components-Defaults).

export type ToastVariant = "success" | "error" | "warning" | "info";

/** Feuert einen Toast am shell-weiten `<pfs-toast-host>` (document.body). */
export function dispatchToast(variant: ToastVariant, title: string, message: string): void {
  document.body.dispatchEvent(new CustomEvent("pfs:toast", { detail: { title, message, variant } }));
}

/** Standard-422-Text — 422 ist das Safety-Net (FE-Validierung + Gating verhindern
 *  es normalerweise); KEIN Custom-422-Text je WC. */
export const STD_422_MESSAGE = "Eingaben ungültig — bitte prüfe deine Angaben.";

/** Standard-Fehler-Toast fuer Save-Operationen (cross-app-Kanon): HTTP-Status → Text.
 *  409 = optionaler Conflict-Text; 422 = Standard-Safety-Net; sonst generisch. */
export function saveErrorToast(e: unknown, conflictMessage?: string): void {
  const status = (e as { status?: number })?.status;
  const message =
    status === 409 && conflictMessage
      ? conflictMessage
      : status === 422
        ? STD_422_MESSAGE
        : "Speichern fehlgeschlagen.";
  dispatchToast("error", "Fehler", message);
}
